export const i18n = {
    defaultLocale: 'en',
    locales: ['en', 'hi']
  };
  
  export const Locale = i18n.locales[0];